module.exports = __webpack_public_path__ + "img/chengyi.8a884716.png";